{
  "title": "Real Estate Tracker",
  "subtitle": "Sign in to continue",
  "username": "Username",
  "password": "Password",
  "rememberMe": "Remember me for 30 days",
  "signIn": "Sign In",
  "signingIn": "Signing in...",
  "contactAdmin": "Contact your administrator for access",
  "validationError": "Username and password are required",
  "loginFailed": "Login failed",
  "loginError": "An error occurred during login",
  "logoutFailed": "Logout failed",
  "profileUpdateFailed": "Profile update failed",
  "passwordChangeFailed": "Password change failed",
  "languageSaveFailed": "Failed to save language preference",
  "sessionExpired": "Session expired - please login again"
}
